import Home from './Home'

export { Home }



// WEBPACK FOOTER //
// ./src/features/Home/containers/index.js